// @LTG-ID: layout
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 07_PAGES_AND_ROUTES.md#layout-chrome
// @CHANGED: 2026-02 session_002
// @OWNER: web
//
// SiteLayout — wraps every route. Composes the always-on chrome:
//   SectorProvider
//     Header  →  ScrollProgressBar  →  <Outlet />  →  Footer
//   + ScrollTopFAB
//   + useUtmPassthrough (defensive safety effect, see ADR-005)

import { Outlet } from "react-router-dom";
import Header from "./Header";
import ScrollProgressBar from "./ScrollProgressBar";
import Footer from "./Footer";
import ScrollTopFAB from "./ScrollTopFAB";
import ScrollToTop from "./ScrollToTop";
import { SectorProvider } from "../../lib/use-sector";
import { useUtmPassthrough } from "../../lib/use-utm-passthrough";

function LayoutInner() {
    useUtmPassthrough();
    return (
        <div className="ltg-app-shell" data-testid="site-layout">
            <ScrollToTop />
            <Header />
            <ScrollProgressBar />
            <main className="ltg-main" data-testid="site-main">
                <Outlet />
            </main>
            <Footer />
            <ScrollTopFAB />
        </div>
    );
}

export const SiteLayout = () => {
    return (
        <SectorProvider>
            <LayoutInner />
        </SectorProvider>
    );
};

export default SiteLayout;
